import config from '../config';
import selectedEnvironment from '../env';

const baseURL = config[selectedEnvironment].API_URL;
const Receivables_API_URL = `${baseURL}/Receivables`;

const buildQueryString = (params) => {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') return;
        search.append(key, value instanceof Date ? value.toISOString() : value);
    });
    return search.toString();
};

/**
 * Returns the Accounts Receivable page payload for a case:
 *   { invoices, cards, totals }
 * Optional filters: dateFrom, dateTo, cardId, status (InvoicePaymentStatus enum).
 */
const GetReceivablesPage = async (caseId, auth, options = {}) => {
    const qs = buildQueryString({
        caseId,
        dateFrom: options.dateFrom,
        dateTo: options.dateTo,
        cardId: options.cardId,
        status: options.status,
    });
    const response = await fetch(`${Receivables_API_URL}/Page?${qs}`, {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + auth,
            'Content-Type': 'application/json',
        },
    });
    return response;
};

/**
 * Returns unsettled invoices for a single account card (dropdown source for the
 * "Linked invoice" Autocomplete on the receipt creation modal).
 */
const GetOutstandingInvoicesForCard = async (caseId, accountCardId, auth) => {
    const qs = buildQueryString({ caseId, accountCardId });
    const response = await fetch(`${Receivables_API_URL}/OutstandingInvoices?${qs}`, {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + auth,
            'Content-Type': 'application/json',
        },
    });
    return response;
};

/**
 * Returns the receipts on a customer card that can be linked to an invoice.
 * Source for the "select existing receipt" picker on the Receivables page.
 */
const GetAvailableReceiptsForCard = async (caseId, accountCardId, auth) => {
    const qs = buildQueryString({ caseId, accountCardId });
    const response = await fetch(`${Receivables_API_URL}/AvailableReceipts?${qs}`, {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + auth,
            'Content-Type': 'application/json',
        },
    });
    return response;
};

/**
 * Links an existing receipt to an invoice. Pass incomeId = null to unlink.
 */
const LinkReceiptToInvoice = async (caseId, receiptId, incomeId, auth) => {
    const response = await fetch(`${Receivables_API_URL}/LinkReceipt`, {
        method: 'PUT',
        headers: {
            Authorization: 'Bearer ' + auth,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            CaseId: caseId,
            ReceiptId: receiptId,
            IncomeId: incomeId || null,
        }),
    });
    return response;
};

const ReceivablesService = {
    GetReceivablesPage,
    GetOutstandingInvoicesForCard,
    GetAvailableReceiptsForCard,
    LinkReceiptToInvoice,
};

export default ReceivablesService;
